import Typography from '@mui/material/Typography';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { ITrade } from "./TradesData";
import { tableHeaderSTyles } from "./styled";
const cols = [{ title: 'Rating' }, { title: 'Certified Date' }, { title: 'Qualification Number' }];

export const Trades = ({ data }: { data: ITrade[] }) => (
  <MainContainer hasGreyBg>
    <Typography sx={tableHeaderSTyles}>Trades <span data-automation="TradesCount">({data.length})</span></Typography>
    <Typography 
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >      
      <ScrollIndicatorsComp>
        <CollapsibleTable
          cols={cols}
          rows={data}
          isOneLevel={true}
        />
      </ScrollIndicatorsComp>
    </Typography>
  </MainContainer>
)